/* This file is part of the Quiz app. It is a wrapper responsible for redirecting users to the sign-up page. */
import { useCallback, useEffect } from 'react';

import history from 'config/history';

import { useAuth } from 'hooks/useAuth';

import { useQuizContext } from '../hooks/useQuizContext';

interface IProps {
  pathPrefix?: string;
}

const QuizSignUp = ({ pathPrefix = '' }: IProps) => {
  const { nextStep } = useQuizContext();
  const { isAuthenticated } = useAuth();

  const handleHref = useCallback(() => {
    if (pathPrefix) {
      history.push(`${pathPrefix}/sign-up`);
    } else {
      history.push('sign-up');
    }
  }, [pathPrefix]);

  useEffect(() => {
    if (isAuthenticated) {
      nextStep();
    } else {
      handleHref();
    }
  }, [isAuthenticated, nextStep, handleHref]);

  return null;
};

export default QuizSignUp;
